// extracted by mini-css-extract-plugin
export default {"app":"App_app__9C3xs","background":"App_background__WUTqP","game":"App_game__9KMRO"};